import { BID_DRAFT_ACTION_MODE } from "interfaces";
import { observer } from "mobx-react-lite";

import { useStores } from "stores";
import { CustomButton } from "ui";

import { BidDraftActionModal } from "./BidDraftActionModal";

export const ReturnToDraftBidBtn = observer(() => {
  const { actionModals } = useStores();

  const openReturnToDraftModal = () => {
    actionModals.open(() => <BidDraftActionModal mode={BID_DRAFT_ACTION_MODE.RETURN_TO_DRAFT} />, {
      width: "600px",
      noValidation: true,
      isOverlayClose: false,
      title: "Вернуть на рассмотрение",
      onApply: () => Promise.resolve(),
    });
  };

  return (
    <CustomButton type="default" onClick={openReturnToDraftModal} tooltip="Вернуть заявку на рассмотрение">
      Вернуть на рассмотрение
    </CustomButton>
  );
});
